import { getNavigateShortcutKeys } from './util';

export const ShortcutType = {
  Navigation: 0,
  ShowHideMainMenu: 1,
  ShowHideHelp: 2,
  ShowHideSecondaryNavigation: 3,
  CreateNew: 4,
  Copy: 5,
  Paste: 6,
  All: 7,
  ShowHideShortcutDialog: 8,
  MainMenu: 9,
  GlobalSearch: 10,
  CollapseTable: 11,
  // campaign types
  AllCampaign: 12,
  DefaultCampaign: 13,
  ShoppingCampaign: 14,
  AudienceCampaign: 15,
  HotelCampaign: 16,
  SmartCampaign: 17,
  CampaignTypes: 18,
};

export const ShortcutTypeKeyMapping = {
  [ShortcutType.ShowHideShortcutDialog]: 'shift+/',
  [ShortcutType.ShowHideMainMenu]: 'shift+w',
  [ShortcutType.ShowHideHelp]: 'shift+h',
  [ShortcutType.AllCampaign]: 'shift+a',
  [ShortcutType.DefaultCampaign]: 'shift+s',
  [ShortcutType.ShoppingCampaign]: 'shift+p',
  [ShortcutType.AudienceCampaign]: 'shift+d',
  [ShortcutType.HotelCampaign]: 'shift+l',
  [ShortcutType.SmartCampaign]: 'shift+t',
  [ShortcutType.CreateNew]: 'shift+n',
  [ShortcutType.Copy]: 'ctrl+c',
  [ShortcutType.Paste]: 'ctrl+v',
  [ShortcutType.GlobalSearch]: 'g+t',
  [ShortcutType.CollapseTable]: 'escape',
  // use the same key as ShowHideMainMenu as they are mutually exclusive. And used for similar purpose.
  [ShortcutType.ShowHideSecondaryNavigation]: 'shift+w',
};

ShortcutTypeKeyMapping[ShortcutType.CampaignTypes] = [
  ShortcutTypeKeyMapping[ShortcutType.AllCampaign],
  ShortcutTypeKeyMapping[ShortcutType.DefaultCampaign],
  ShortcutTypeKeyMapping[ShortcutType.ShoppingCampaign],
  ShortcutTypeKeyMapping[ShortcutType.AudienceCampaign],
  ShortcutTypeKeyMapping[ShortcutType.HotelCampaign],
  ShortcutTypeKeyMapping[ShortcutType.SmartCampaign],
].join(',');

ShortcutTypeKeyMapping[ShortcutType.MainMenu] = [
  ShortcutTypeKeyMapping[ShortcutType.ShowHideMainMenu],
  ShortcutTypeKeyMapping[ShortcutType.CampaignTypes],
].join(',');

const getAllShortcutList = siteMap =>
  `${getNavigateShortcutKeys(siteMap)},${ShortcutTypeKeyMapping[ShortcutType.MainMenu]},${ShortcutTypeKeyMapping[ShortcutType.ShowHideHelp]},${ShortcutTypeKeyMapping[ShortcutType.Copy]},${ShortcutTypeKeyMapping[ShortcutType.Paste]},${ShortcutTypeKeyMapping[ShortcutType.GlobalSearch]},${ShortcutTypeKeyMapping[ShortcutType.CollapseTable]},${ShortcutTypeKeyMapping[ShortcutType.CreateNew]},${ShortcutTypeKeyMapping[ShortcutType.ShowHideShortcutDialog]}`;

export const getShortcutList = (type, siteMap) => {
  if (type === ShortcutType.All) {
    return getAllShortcutList(siteMap);
  } else if (type === ShortcutType.Navigation) {
    return getNavigateShortcutKeys(siteMap);
  }
  return ShortcutTypeKeyMapping[type];
};
